export default __webpack_public_path__ + "static/media/d27.dd7b0ac3.jpeg";